import React, {Component} from 'react';
import { SearchBox } from '../Search/search.component';

import './filters-dropdown.styles.scss';

class FiltersDropdown extends Component {
    stickyNav(){
        const filters = document.querySelector('.filters-nav');
        const filtersHeight = filters.offsetHeight;
        const filtersWrapper = document.querySelector('.filters-dropdown');
        const sticky = filtersWrapper.offsetTop;

        const dropdown = document.querySelector('.dropdown-wrapper');
        const trigger = document.querySelector('.filters-trigger');

        window.addEventListener('scroll', function(){
          if (window.pageYOffset >= sticky) {
            filters.classList.add("sticky");
            filtersWrapper.style.paddingTop = filtersHeight + 'px';
          } else {
            filters.classList.remove("sticky");
            filtersWrapper.style.paddingTop = '0px';
          }
    
          if ((window.innerHeight + window.pageYOffset) >= (document.body.offsetHeight - 100)) {
            filters.classList.add("hide");
            dropdown.classList.remove('active');
            trigger.classList.remove('open');
          } else {
            filters.classList.remove("hide");
          }
        })
    }

    addActiveFilters = () => {
        const channel = this.props.channel;
        const channelBtn = document.querySelector(`.filter.single[data-value="${channel}"]`);
        if (channelBtn) {
            channelBtn.classList.add('active')
        }

        const filters = this.props.filters;

        if (filters.length > 0) {
            filters.forEach(filter => {
                const filterBtn = document.querySelector(`.filter[data-value="${filter}"]`)
                filterBtn.classList.add('active')
            })
        }
    }

    componentDidMount() {
        this.stickyNav();
    }

    render(){
        const channelLength = this.props.channel.length !== 0 ? 1 : 0;
        const filterCount = this.props.filters.length + channelLength;
        this.addActiveFilters();

        return (
            <div className="filters-dropdown">
                <div className="filters-nav">
                    <div className="container">
                        <div className="filters-wrapper">
                            <button className="filters-trigger" onClick={this.props.handleDropdown}>
                                <span className="btn__content" tabIndex="-1">
                                Filters
                                {
                                    filterCount > 0 &&
                                    <> 
                                        <span className="filter-count"> ({filterCount})</span>
                                    </>
                                }
                                </span>
                            </button>
                            {
                                filterCount > 0 &&
                                <button className="trigger-clear main" onClick={this.props.handleClearFilters}>Clear</button>
                            }
                            <div className="dropdown-wrapper">
                                <div className="dropdown-mobile">
                                    <h2>Filters</h2>
                                    <button className="close-filters" onClick={this.props.handleDropdown}><span></span><span></span></button>
                                </div>
                                <h2>Type</h2>
                                <div className="selects-wrapper">
                                    <button className="filter" data-value="CrowdRiff Use Case" onClick={this.props.handleFilterClick}>CrowdRiff Use Case</button>
                                    <button className="filter" data-value="Experiential" onClick={this.props.handleFilterClick}>Experiential</button>
                                    <button className="filter" data-value="Social Media" onClick={this.props.handleFilterClick}>Social Media</button>
                                    <button className="filter" data-value="Video" onClick={this.props.handleFilterClick}>Video</button><button className="filter" data-value="Website" onClick={this.props.handleFilterClick}>Website</button>
                                </div>
                                <h2>Industry</h2>
                                <div className="selects-wrapper">
                                    <button className="filter single" data-value="Destinations" onClick={this.props.handleChannelClick}>Destinations</button>
                                    <button className="filter single" data-value="Attractions" onClick={this.props.handleChannelClick}>Attractions</button>
                                </div>
                                <div className="buttons-wrapper">
                                    <button className="btn trigger-apply" onClick={this.props.handleApplyFilters}>Apply Filters</button>
                                    <button className="trigger-clear" onClick={this.props.handleClearFilters}>Clear Filters</button>
                                </div>
                            </div>
                        </div>
                        <SearchBox 
                            handleSearch={this.props.handleSearch}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default FiltersDropdown;